class heroSlider extends HTMLElement {
  constructor() {
    super();

    const slider = this.querySelector('[data-hero-slider]');
    if (!slider) return;

    new Swiper(slider, {
      slidesPerView: 1,
      loop: this.querySelectorAll('.swiper-slide').length > 1,
      effect: 'slide',
      speed: 1000,
      navigation: {
        nextEl: slider.querySelector('.hero__button-next'),
        prevEl: slider.querySelector('.hero__button-prev')
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  }
}

customElements.define('hero-slider', heroSlider);